import { createObjectSchema, createStringSchema } from '@dreryk/react-draft';

import { referralCommonDraftSchema } from '../referral.draft';
import { icd9ProcedureSchema } from '../shared/Icd9ProcedureField/Icd9ProcedureField.draft';
import {
   HealthcareFacilityLocationSpecialtyDraft,
   healthcareFacilityLocationSpecialtySchema,
} from '../shared/HealthcareFacilitySpecialtyField/HealthcareFacilityLocationSpecialty.draft';

import { ReferralToHospitalFormBean } from './ReferralToHsopitalForm/ReferralToHospitalForm.types';

type ReferralToHospitalDraftSchema = Omit<ReferralToHospitalFormBean, 'healthcareFacilityLocationSpecialty'> & {
   healthcareFacilityLocationSpecialty: HealthcareFacilityLocationSpecialtyDraft;
};

export const referralToHospitalDraftSchema = createObjectSchema<ReferralToHospitalDraftSchema>({
   unitNameAndAddress: createStringSchema().nullable(),
   additionalInformation: createStringSchema().nullable(),
   icd9Procedures: icd9ProcedureSchema.array(),
})
   .strict()
   .merge(referralCommonDraftSchema)
   .merge(healthcareFacilityLocationSpecialtySchema);
